/*
 * Frame Cart Sync — hält Poster+Rahmen-Bundles konsistent (_bundle_id).
 * Regeln: Waise (halbes Bundle) wird entfernt; Rahmenmenge folgt Postermenge.
 * Läuft auf jeder Seite (theme.liquid); reagiert auf Impacts cart:change.
 */
(function () {
  'use strict';

  let running = false;

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function reconcile(cart) {
    if (running || !cart || !Array.isArray(cart.items)) return false;
    running = true;
    try {
      const bundles = {};
      cart.items.forEach((item) => {
        const bundleId = item.properties && item.properties._bundle_id;
        if (!bundleId) return;
        const role = item.properties._bundle_role === 'rahmen' ? 'rahmen' : 'poster';
        (bundles[bundleId] = bundles[bundleId] || {})[role] = item;
      });

      const changes = [];
      Object.entries(bundles).forEach(([bundleId, bundle]) => {
        if (window.__framePendingBundles && window.__framePendingBundles[bundleId]) return;
        if (bundle.poster && !bundle.rahmen) changes.push({ id: bundle.poster.key, quantity: 0 });
        else if (bundle.rahmen && !bundle.poster) changes.push({ id: bundle.rahmen.key, quantity: 0 });
        else if (bundle.rahmen.quantity !== bundle.poster.quantity) changes.push({ id: bundle.rahmen.key, quantity: bundle.poster.quantity });
      });
      if (changes.length === 0) return false;

      for (const change of changes) {
        await fetch(`${routesRoot()}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(change),
        });
      }
      return true;
    } catch (error) {
      return false;
    } finally {
      running = false;
    }
  }

  document.addEventListener('cart:change', async (event) => {
    if (await reconcile(event.detail && event.detail.cart)) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  });

  // Cart-SEITE lädt bei Änderungen komplett neu → beim Seitenaufbau prüfen
  const isCartPage = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart')
    || window.location.pathname.replace(/\/$/, '').endsWith('/cart');
  if (isCartPage) {
    (async () => {
      try {
        const cart = await (await fetch(`${routesRoot()}cart.js`)).json();
        if (await reconcile(cart)) window.location.reload();
      } catch (error) { /* still ok — nächster cart:change greift */ }
    })();
  }
})();
